
import {headerBundle} from '../features/header-bundle';
import {register} from '../vendor/theme-scripts/theme-sections';

const sections = [];

class BundleBuilder {
  constructor(section) {
    this.section = section;
    this.container = section.container;

    this.init();
    this.step();
  }

  init() {
    headerBundle();
  }

  step() {
    console.log('BundleBuilder.step');
    console.log(window.location.search.indexOf(`step=complete`))

    if( window.location.search.indexOf(`step=complete`) !== -1 ) {
      this.container.querySelector(`[bunlde-step="complete"]`).style.display = 'block';
    } else {
      this.container.querySelector(`[bunlde-step="choose"]`).style.display = 'block';
    }
  }
}

const bundleBuilder = {
  onLoad() {
    sections[this.id] = new BundleBuilder(this);
  },
  onUnload() {
    if (typeof sections[this.id].unload === 'function') {
      sections[this.id].unload();
    }
  },
};

register('page-bundle-builder', [bundleBuilder]);
